// extracted by mini-css-extract-plugin
export var col = "teach-module--col--3ee7c";
export var desc = "teach-module--desc--aa20c";
export var item = "teach-module--item--09be0";
export var item1 = "teach-module--item--1--85e56";
export var item2 = "teach-module--item--2--9dfbb";
export var photo = "teach-module--photo--17eb2";
export var photo1 = "teach-module--photo--1--c8597";
export var photo2 = "teach-module--photo--2--f6551";
export var subtitle = "teach-module--subtitle--b94c0";
export var teach = "teach-module--teach--0f9ad";
export var text = "teach-module--text--f26cb";